<template>
  <div class="suggest-overview" :class="isTemplate ? 'w-100 ml-0 mt-3' : ''">
    <div class="suggest-overview-title">{{ $t('bill.text_175') }}</div>
    <div class="suggest-overview-header mt-3">
      <div class="header-title">
        <div class="header-title-item">{{$t('bill.text_175')}}</div>
        <div class="header-title-item">{{$t('subscription.suggest_resource')}}</div>
        <div class="header-title-item">{{$t('subscription.effect_suggest')}}</div>
        <div class="header-title-item">{{$t('subscription.effect_suggest_resource')}}</div>
        <div class="header-title-item">{{$t('subscription.ignore_suggest_resource')}}</div>
      </div>
      <div class="header-value">
        <div class="header-value-item"><span class="suggest-overview-header-item-number" @click="() => handleClick('suggestsysalert', {group_by: 'type'})">{{ data.alert_count || 0 }}</span>{{$t('bill.suggest_unit')}}</div>
        <div class="header-value-item"><span class="suggest-overview-header-item-number" @click="() => handleClick('suggestsysalert', {group_by: 'res'})">{{ data.alert_resource_count || 0 }}</span>{{$t('bill.text_272')}}</div>
        <div class="header-value-item"><span class="suggest-overview-header-item-number" @click="() => handleClick('suggestsysalert', {group_by: 'type', status: 'resolved'})">{{ data.alert_effect_count || 0 }}</span>{{$t('bill.suggest_unit')}}</div>
        <div class="header-value-item"><span class="suggest-overview-header-item-number" @click="() => handleClick('suggestsysalert', {group_by: 'res', status: 'resolved'})">{{ data.alert_effect_resource_count || 0 }}</span>{{$t('bill.text_272')}}</div>
        <div class="header-value-item"><span class="suggest-overview-header-item-number" @click="() => handleClick('suggestsysruleconfig', {})">{{ data.alert_ignore_count || 0 }}</span>{{$t('bill.text_272')}}</div>
      </div>
    </div>
    <vxe-grid v-if="!isTemplate" class="mt-3" style="width: 100%;" :data="suggestList" :columns="columns" resizable />
  </div>
</template>

<script>
import i18n from '@/locales'
import {
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import { SUGGEST_RULE_RESOURCE_TYPES_MAP } from '@Bill/constants'
import {
  getSuggestRuleTableColumn,
  getSuggestMethodTableColumn,
  getPublicScopeTableColumn,
} from '@Bill/utils/columns'

export default {
  name: 'SuggestOverview',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    suggestList: {
      type: Array,
      default: () => [],
    },
    time: {
      type: String,
      default: 'month',
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      columns: [
        {
          field: 'res_name',
          title: i18n.t('bill.text_127'),
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [
                <div class='text-truncate'>
                  <list-body-cell-wrap copy row={row} field='res_name' title={row.res_name} hideField={true}>
                    {this.group_by === 'res' ? <side-page-trigger permission='suggestsysalerts_get' name='SuggestsAlertSidePage' id={row.res_id} vm={this} onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger> : row.name}
                  </list-body-cell-wrap>
                  <list-body-cell-wrap copy row={row} field='res_id' hideField title={row.res_id}><span style="color: #999;">{row.res_id}</span></list-body-cell-wrap>
                </div>,
              ]
            },
          },
          formatter: ({ row }) => {
            return row.name
          },
        },
        getCopyWithContentTableColumn({
          field: 'ip_addr',
          title: 'IP',
          isTypeHide: true,
        }),
        {
          field: 'rule_name',
          title: i18n.t('meter.rule_name'),
          isResHide: true,
          slots: {
            default: ({ row }) => {
              return [
                <div class='text-truncate'>
                  <list-body-cell-wrap copy row={row} field='rule_name' title={row.rule_name} />
                </div>,
              ]
            },
          },
          formatter: ({ row }) => {
            return row.rule_name
          },
        },
        getSuggestRuleTableColumn(),
        {
          field: 'resource_type',
          title: this.$t('bill.text_73'),
          formatter: ({ row }) => {
            return SUGGEST_RULE_RESOURCE_TYPES_MAP[row.res_type].label
          },
        },
        getSuggestMethodTableColumn(),
        getPublicScopeTableColumn(),
        {
          field: 'usage_type',
          title: this.$t('bill.usage_type'),
        },
        {
          field: 'origin_usage',
          title: this.$t('meter.origin_usage'),
        },
        {
          field: 'suggest_usage',
          title: this.$t('meter.suggest_usage'),
        },
        {
          field: 'usage_unit',
          title: this.$t('meter.usage_unit'),
        },
      ],
    }
  },
  methods: {
    handleClick (path, query) {
      let month = [this.$moment().format('YYYY-MM'), this.$moment().format('YYYY-MM')]
      if (this.time === 'last_month') {
        month = [this.$moment().subtract(1, 'month').format('YYYY-MM'), this.$moment().subtract(1, 'month').format('YYYY-MM')]
      } else if (this.time === 'year') {
        month = [this.$moment().startOf('year').format('YYYY-MM'), this.$moment().endOf('year').format('YYYY-MM')]
      }
      // const q = { ...query }
      // if (q.group_by !== 'res') {
      //   q.month = month
      // }
      this.$router.push({
        path,
        query: { ...query, month },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.suggest-overview {
  border: 1px solid #e8e8e8;
  padding: 12px;
  border-radius: 3px;
  width: 66%;
  flex: 1 1 auto;
  margin-left: 12px;
  .suggest-overview-header {
    .header-title {
      display: flex;
      justify-content: space-between;
      .header-title-item {
        text-align: center;
        width: 20%;
      }
    }
    .header-value {
      display: flex;
      justify-content: space-between;
      .header-value-item {
        text-align: center;
        width: 20%;
        .suggest-overview-header-item-number {
          font-size: 2.5em;
          margin-left: 10px;
          margin-right: 10px;
          color: var(--antd-wave-shadow-color);
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
